import(/* webpackMode: "eager" */ "C:\\xampp\\htdocs\\enthioshub\\enthioshub\\frontend\\src\\app\\(system)\\dashboard\\organization\\page.tsx");
